module.exports = __webpack_public_path__ + "img/whiteCross.22f71fef.svg";